import * as yup from "yup";

const errorMessages = {
  required: "Campo obrigatório",
  mustHaveFields: "Must have fields",
  minOneField: "Minimum of 1 field",
  selectOption: "Selecione uma opção",
  invalidPillarName: "Nome de pilar inválido",
  themesLength: "O número de temas deve ser igual ao valor de numberOfThemes",
  levelsLength: "O número de níveis deve ser igual ao valor de numberOfLevels",
};

const numberOfThemesOptions = [
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "10",
  "11",
  "12",
];

const numberOfLevelsOptions = ["1", "2", "3", "4", "5"];

const levelsSchema = yup.object().shape({
  nivel: yup.number().required(errorMessages.required),
  questions: yup
    .array()
    .of(
      yup.object().shape({
        id_question_template: yup.number().required(errorMessages.required),
      })
    )
    .required(errorMessages.mustHaveFields)
    .min(1, errorMessages.minOneField),
});

const themeSchema = yup.object().shape({
  title: yup.string().required(errorMessages.required),
});

const baseSchema = yup.object().shape({
  pillarName: yup.string().required(errorMessages.invalidPillarName),
  numberOfThemes: yup
    .mixed()
    .oneOf(numberOfThemesOptions, errorMessages.selectOption)
    .required(errorMessages.selectOption),
  numberOfLevels: yup
    .mixed()
    .oneOf(numberOfLevelsOptions, errorMessages.selectOption)
    .required(errorMessages.selectOption),
});

const newFieldSchema = yup.object().shape({
  pillarText: yup.string().required(errorMessages.required),
  pillarImage: yup.string(),
  helpTitle: yup.string().required(errorMessages.required),
  helpText: yup.string().required(errorMessages.required),
  themes: yup
    .array()
    .of(themeSchema)
    .required(errorMessages.required)
    .test("themes-length", errorMessages.themesLength, function (themes) {
      const { numberOfThemes } = this.parent;
      return themes.length === Number(numberOfThemes);
    }),
  levels: yup
    .array()
    .of(levelsSchema)
    .required(errorMessages.required)
    .test("levels-length", errorMessages.levelsLength, function (levels) {
      const { numberOfLevels } = this.parent;
      return levels.length === Number(numberOfLevels);
    }),
});

const createDiagnosisSchema = (formSchema) =>
  yup.object().shape({
    name: yup.string().required(errorMessages.required),
    form: yup
      .array()
      .of(formSchema)
      .required(errorMessages.mustHaveFields)
      .min(1, errorMessages.minOneField),
  });

export const diagnosisRegisterSchema = createDiagnosisSchema(baseSchema);

export const diagnosisRegisterSchemaUpdate =
  createDiagnosisSchema(newFieldSchema);
